import React from "react";
import { Table, Button, Popconfirm, Space } from "antd";

const CamposTable = ({ 
  campos, 
  setSelectedCampo, 
  setValoresCampo, 
  setIsModalOpen, 
  setIsEditModalOpen,
  handleEliminarCampo
}) => {
  const handleVerValores = (campo) => {
    setSelectedCampo(campo);
    setIsModalOpen(true);
  };

  const handleEditarCampo = (campo) => {
    setSelectedCampo(campo);
    setIsEditModalOpen(true);
  };

  const columns = [
    {
      title: "Campo",
      dataIndex: "campo",
      key: "campo",
    },
    {
      title: "Tipo",
      dataIndex: "tipo_campo",
      key: "tipo_campo",
    },
    {
      title: "Acciones",
      key: "acciones",
      render: (_, record) => (
        <Space>
          <Button type="link" onClick={() => handleVerValores(record)}>
            Ver Valores
          </Button>
          <Button type="link" onClick={() => handleEditarCampo(record)}>
            Editar
          </Button>
          <Popconfirm
            title="¿Estás seguro de eliminar este campo y sus valores?"
            onConfirm={() => handleEliminarCampo(record.id)}
            okText="Sí"
            cancelText="No"
          >
            <Button type="link" danger>
              Eliminar
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return <Table dataSource={campos} columns={columns} rowKey="id" pagination={false} />;
};

export default CamposTable; 